angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("notifications-template.html", "<div class=\"notifications\"> <div class=\"notification-msg pusher {{notification.type || ''}}\" ng-repeat=\"notification in data.notifications track by $index\"> <div class=\"container\" ng-bind-html=\"notification.msg\">{{notification.msg}}</div> </div> <div class=\"notification-msg {{notification.type || ''}}\" ng-repeat=\"notification in data.notifications track by $index\"> <div class=\"container text-center\" ng-bind-html=\"notification.msg\">{{notification.msg}}</div> </div> </div>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/notifications-template.html
 ** module id = 85
 ** module chunks = 0
 **/